import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ResetPasswordForm } from 'components';

export const ResetPassword = () => {
	const [queryString] = useSearchParams();
	const token = queryString.get('token') || '';
	const email = queryString.get('email') || '';

	return (
		<>
			<ResetPasswordForm email={email} token={token}/>
		</>
	);
}
